import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import ServiceDetailsContentf from '../components/ServiceDetailsf/ServiceDetailsContentf'
import RelatedServicesf from '../components/ServiceDetailsf/RelatedServicesf'

const Details = () => {
    return (
        <Layout>
            <Navbar />
            <PageBanner
                pageTitle="Plant Maintenance "
                homePageText="Home"
                homePageUrl="/"
                activePageText="Service Details"
            />
            <ServiceDetailsContentf />
            <RelatedServicesf />
            <Footer />
        </Layout>
    );
}

export default Details